import apiEventsCompetitionsSearch from '@/api/еvents-сompetitions-search.js'

const state = {
  data: [],
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getEventsCompetitionsSearchStart:
    '[еvents сompetitions search list] Get еvents сompetitions search list start',
  getEventsCompetitionsSearchSuccess:
    '[еvents сompetitions search list] Get еvents сompetitions search list success',
  getEventsCompetitionsSearchFailure:
    '[еvents сompetitions search list] Get еvents сompetitions search list failure',
}

export const actionTypes = {
  getEventsCompetitionsSearch:
    '[еvents сompetitions search list] Get еvents сompetitions search list',
}

const mutations = {
  [mutationTypes.getEventsCompetitionsSearchStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getEventsCompetitionsSearchSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getEventsCompetitionsSearchFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getEventsCompetitionsSearch](context, {type, params}) {
    context.commit(mutationTypes.getEventsCompetitionsSearchStart)
    return new Promise((resolve) => {
      apiEventsCompetitionsSearch
        .getEventsAndCompetitionsList(type, params)
        .then((response) => {
          context.commit(
            mutationTypes.getEventsCompetitionsSearchSuccess,
            response
          )
          resolve(response)
        })
        .catch((error) => {
          context.commit(
            mutationTypes.getEventsCompetitionsSearchFailure,
            error
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
